import { ButtonTheme, ButtonToolTip } from '../../../../components';
import {
  createColumnButtonArr,
  createColumnText,
  widthOptions,
} from '@/components/table/function/createColumn';
import { createColumnTag } from '../../../../components/table/function/createColumn';
import { STATUS_OPTIONS } from '../../../../resources/status';

export const columns = ({ onEdit }) => {
  return [
    createColumnTag(
      'สถานะ',
      { key: 'mobileBrandStatus', text: 'mobileBrandStatus', icon: true },
      STATUS_OPTIONS,
    ),
    createColumnText('รหัสแบรนด์', 'mobileBrandCode', widthOptions(150)),
    createColumnText('ชื่อแบรนด์', 'mobileBrandNameTh', widthOptions(150)),
    createColumnButtonArr('จัดการ', 'rowNo', {
      others: {
        fixed: 'right',
        width: 150,
      },
      buttonArr: [
        {
          useFor: 'EDIT3',
          render: (text, record) => (
            <ButtonToolTip toolTip="แก้ไข" placement="topLeft">
              <ButtonTheme useFor="EDIT3" onClick={() => onEdit(record)} />
            </ButtonToolTip>
          ),
        },
      ],
    }),
  ];
};
